import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Tab = ({ tab, current, setTab }) => {
  const activeStyles = {
    borderBottom: "1px solid var(--denim)",
    fontWeight: "bold",
  };
  const inactiveStyles = {};
  const tabStyle = tab === current ? activeStyles : inactiveStyles;

  const onClick = (event, tab) => {
    event.stopPropagation();
    setTab(tab);
  };

  return (
    <TabListItem
      key={tab}
      onClick={(e) => onClick(e, tab)}
      style={tabStyle}
      className="Tab"
    >
      {tab}
    </TabListItem>
  );
};
Tab.propTypes = {
  tab: PropTypes.string,
  current: PropTypes.string,
  setTab: PropTypes.func,
};

const Tabs = ({ current, tabs, setTab, testid = "tabs", className = "" }) => {
  return (
    <TabsList className={className} data-testid={testid}>
      {tabs.map((tab) => (
        <Tab tab={tab} key={tab} setTab={setTab} current={current} />
      ))}
    </TabsList>
  );
};
Tabs.displayName = "Tabs";
Tabs.propTypes = {
  tabs: PropTypes.array,
  className: PropTypes.string,
  current: PropTypes.string,
  setTab: PropTypes.func,
  testid: PropTypes.string,
};
export default Tabs;

export const TabListItem = styled.li`
  display: inline-block;
  margin-bottom: -1px;
  padding: 2px 20px;
  color: var(--denim);

  &:first-child {
    margin-left: 10px;
  }
`;

export const TabsList = styled.ul`
  border-bottom: 1px solid var(--gallery);
  margin-left: -10px;
  margin-right: -10px;
  margin-bottom: 10px;
`;
